__turbopack_context__.v({
  "accordionSlideOverwrite": "form-module-scss-module__WKFhGq__accordionSlideOverwrite",
  "actionsRow": "form-module-scss-module__WKFhGq__actionsRow",
  "fadeIn": "form-module-scss-module__WKFhGq__fadeIn",
  "fadeOut": "form-module-scss-module__WKFhGq__fadeOut",
  "forgotLink": "form-module-scss-module__WKFhGq__forgotLink",
  "label": "form-module-scss-module__WKFhGq__label",
  "rememberLabel": "form-module-scss-module__WKFhGq__rememberLabel",
  "rememberMe": "form-module-scss-module__WKFhGq__rememberMe",
  "scaleIn": "form-module-scss-module__WKFhGq__scaleIn",
  "scaleOut": "form-module-scss-module__WKFhGq__scaleOut",
  "zoomIn": "form-module-scss-module__WKFhGq__zoomIn",
  "zoomOut": "form-module-scss-module__WKFhGq__zoomOut",
});
